var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { addManageUsersApi } from '../../../api/b2b/add-manage-user';
import { generateUserTendersPayload } from '../../../utils/form';
import { setEditUserSuccessAnalytics } from '../../../utils/add-manage-user-analytics';
export var manageUserUtils = {
    addUser: function (formData) {
        var firstName = formData.firstName, lastName = formData.lastName, email = formData.email, role = formData.role;
        return addManageUsersApi
            .addUser({
            firstName: firstName,
            lastName: lastName,
            email: email,
            role: role,
        })
            .then(function (_a) {
            var data = _a.data;
            if (!data.users[0]) {
                throw new Error('no user is found');
            }
            return data.users[0];
        });
    },
    editUser: function (values, editableUser) {
        var role = values.role;
        if (!role || !editableUser) {
            throw new Error('no role or user provided');
        }
        var payload = __assign(__assign({}, editableUser), { role: role });
        return addManageUsersApi.updateUser(payload).then(function (_a) {
            var data = _a.data;
            if (role)
                setEditUserSuccessAnalytics(role);
            if (!data.users[0]) {
                throw new Error('no user is found');
            }
            return data.users[0];
        });
    },
    handlePaymentPermissionsUpdate: function (userId, selectedPaymentIds, originalPaymentPermissions) {
        var updateUserTendersPayload = generateUserTendersPayload(selectedPaymentIds, originalPaymentPermissions);
        if (updateUserTendersPayload) {
            return addManageUsersApi
                .updateUserTendersPermissions(updateUserTendersPayload, userId)
                .then(function (_a) {
                var data = _a.data;
                if (!data.success) {
                    throw new Error('Failed to update payment permissions');
                }
                return data;
            });
        }
        return Promise.resolve();
    },
};
